
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/ncaa-basketball-analysis",
      function () {
        return require("private-next-pages/blog/ncaa-basketball-analysis.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/ncaa-basketball-analysis"])
      });
    }
  